import { render, staticRenderFns } from "./selftaken-photo.vue?vue&type=template&id=64308e17&lang=pug&"
import script from "./selftaken-photo.vue?vue&type=script&lang=js&"
export * from "./selftaken-photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64308e17')) {
      api.createRecord('64308e17', component.options)
    } else {
      api.reload('64308e17', component.options)
    }
    module.hot.accept("./selftaken-photo.vue?vue&type=template&id=64308e17&lang=pug&", function () {
      api.rerender('64308e17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/selfTakenPhoto/selftaken-photo.vue"
export default component.exports